var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useCallback, useRef, useEffect } from 'react';
import styled from 'styled-components';
import Button from './Button';
const StyledButton = styled(Button) `
  position: fixed;
  border: none;
  border-radius: 3em 0 0 3em;
  bottom: 30px;
  right: ${(props) => (props.isExpanded ? '0px' : '-125px')};
  display: flex;
  align-items: center;
  width: 155px;
  transition: right ease-in-out 0.3s;
  padding: 12px 20px 12px 15px;
  font-size: 16px;

  &:focus {
    outline: none;
  }
`;
/**
 * Primary UI component for user interaction
 */
const HomeButton = (_a) => {
    var { label = '', onClick = () => { } } = _a, props = __rest(_a, ["label", "onClick"]);
    const timeout = useRef(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isClickable, setIsClickable] = useState(false);
    useEffect(() => {
        if (timeout.current) {
            clearInterval(timeout.current);
            setIsClickable(false);
        }
        timeout.current = setTimeout(() => {
            setIsClickable(isExpanded);
        }, 300);
    }, [isExpanded]);
    const handleOnClick = useCallback((event) => {
        event.preventDefault();
        if (isClickable) {
            onClick(event);
        }
    }, [isClickable, onClick]);
    return (React.createElement(StyledButton, Object.assign({ size: "large", backgroundColor: "white", onMouseEnter: () => setIsExpanded(true), onMouseLeave: () => setIsExpanded(false), onFocus: () => setIsExpanded(true), onBlur: () => setIsExpanded(false), onClick: handleOnClick, isExpanded: isExpanded }, props),
        React.createElement("svg", { width: "20", height: "28" },
            React.createElement("circle", { cx: "3.5", cy: "3.5", r: "3.5", fill: "#ff9800" }),
            React.createElement("circle", { cx: "3.5", cy: "14", r: "3.5", fill: "#03a9f4" }),
            React.createElement("circle", { cx: "3.5", cy: "24.5", r: "3.5", fill: "#cddc39" })),
        React.createElement("div", null, label)));
};
export default HomeButton;
